import { useState } from "react";
import { format } from "date-fns";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarBlank } from "@phosphor-icons/react";

const cls = "bg-[#060B14] border border-[#1E293B] focus:border-[#D4AF37] outline-none rounded-md px-3 py-2 text-white text-sm";
const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

export const emptyDateTime = { date: null, hour: "10", minute: "00", ampm: "AM" };

export const toIso = ({ date, hour, minute, ampm }) => {
  if (!date) return null;
  const d = new Date(date);
  let h = Number(hour) % 12;
  if (ampm === "PM") h += 12;
  d.setHours(h, Number(minute), 0, 0);
  return d.toISOString();
};

export const formatFollowup = (iso) => {
  const d = new Date(iso);
  return iso && !isNaN(d) ? format(d, "dd MMM yyyy, hh:mm a") : "Date not set";
};

export function FollowupDateTime({ value, onChange, testidPrefix = "fu-add" }) {
  const t = testidPrefix;
  const [open, setOpen] = useState(false);
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="fu-datetime">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button type="button" data-testid={`${t}-date`} className={`${cls} flex items-center gap-2 min-w-[150px]`}>
            <CalendarBlank size={16} className="text-[#D4AF37]" />
            <span className={value.date ? "" : "text-slate-500"} data-testid={`${t}-date-value`}>{value.date ? format(value.date, "dd MMM yyyy") : "Select date"}</span>
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0 bg-[#0A1120] border-[#1E293B] text-white" align="start">
          <Calendar mode="single" selected={value.date} onSelect={(d) => { if (d) { set("date", d); setOpen(false); } }} initialFocus />
        </PopoverContent>
      </Popover>
      <select value={value.hour} onChange={e => set("hour", e.target.value)} data-testid={`${t}-hour`} className={cls} aria-label="Hour">
        {HOURS.map(h => <option key={h} value={h}>{h}</option>)}
      </select>
      <span className="text-slate-400">:</span>
      <select value={value.minute} onChange={e => set("minute", e.target.value)} data-testid={`${t}-minute`} className={cls} aria-label="Minute">
        {MINUTES.map(m => <option key={m} value={m}>{m}</option>)}
      </select>
      <select value={value.ampm} onChange={e => set("ampm", e.target.value)} data-testid={`${t}-ampm`} className={cls} aria-label="AM/PM">
        <option>AM</option><option>PM</option>
      </select>
    </div>
  );
}
